import SideBarExpanded from './SideBarExpanded';

export default SideBarExpanded;
